import { tab } from '@testing-library/user-event/dist/tab';
import React, { useState } from 'react';
import { Link } from "react-router-dom"
import { Outlet } from "react-router-dom"

const BrowsePage = () => {
  const [tab, setTab] = useState('Services');

  return (
    <>
      <div className='browsePage' >
        <h1>Browse</h1>
        <div className='browseTabsPanel' style={{}}>
        </div>
          <nav className='browseTabsPanel'>
            <Link className='RegisterResetButtons' to="/browse/artists" >
              <h2 className={tab === 'Services' ? 'browseTabs browseTabsSelected' : 'browseTabs'}  onClick={() => setTab('Services')}>Services</h2>
            </Link>
            <Link className='RegisterResetButtons'to="/browse/artists-search" >
              <h2 className={tab === 'SearchServ' ? 'browseTabs browseTabsSelected' : 'browseTabs'} onClick={() => setTab('SearchServ')}>Search Services</h2>
            </Link>
            <Link className='RegisterResetButtons' to="/browse/venues" >
              <h2 className={tab === 'Venues' ? 'browseTabs browseTabsSelected' : 'browseTabs'} onClick={() => setTab('Venues')}>Registered venues</h2>
            </Link>
            {/* <Link className='RegisterResetButtons' to="/browse/venues-search" >
              <h2 className={tab === 'searchVen' ? 'browseTabs browseTabsSelected' : 'browseTabs'} onClick={() => setTab('searchVen')}>Search venues</h2>
            </Link> */}
          </nav>
        <hr style={{ borderBottom: '1px solid var(--ltg)', marginBlock: 20, width: '100%' }} />
        <Outlet />
      </div>
    </>
  );
};

export default BrowsePage;